import { errorMessages, notifyError } from "../components/flash_alert";
import { post } from "@rails/request.js";
import { TURBO_STREAM_ACCEPT_HEADER } from "../utils/constants";

// NOTE(Jonathan Jalal): This generic function will only work as expected for ajax:complete events, not other ajax:* events
export const handleHttpResponse = (data) => {
  const { status, response } = data.payload;
  if (status < 300) {
    data.onSuccess(response);
  } else {
    if ("onError" in data) {
      data.onError(response, status);
    } else {
      notifyError(errorMessages(status));
    }
  }

  if ("onComplete" in data) {
    data.onComplete();
  }
};

export const postTurboRequest = (url, body) => {
  post(url, {
    responseKind: "turbo-stream",
    body: body,
  });
};

export const postAjaxRequest = (url, body = "") => {
  const promise = fetch(url, {
    method: "post",
    headers: {
      "X-CSRF-Token": Rails.csrfToken(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  return promise;
};

export const patchAjaxRequest = (url, body = "") => {
  const promise = fetch(url, {
    method: "PATCH",
    headers: {
      "X-CSRF-Token": Rails.csrfToken(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  return promise;
};

export const alertJsonResponseError = (responseBody, status) => {
  try {
    const message = JSON.parse(responseBody).error_message;
    notifyError(message);
  } catch (error) {
    notifyError(errorMessages(status));
  }
};

export const isTurboStreamResponse = (xhr) => {
  const contentType = xhr.getResponseHeader("Content-Type");
  return contentType.includes(TURBO_STREAM_ACCEPT_HEADER);
};
